export default __webpack_public_path__ + "static/media/logo-white.817fcba8.png";